import { RoutePath } from '../../../constants';
import { ACCOUNT_MANAGEMENT, SIGN_OUT, SWITCH_ORGANIZATION } from '../../../pages/AccountManagement/constants';
import { UserCardItem, UserCardItemTitles } from './types';

export const USER_CARD_ITEM_TITLES: UserCardItemTitles = {
  accountManagement: ACCOUNT_MANAGEMENT,
  switchOrg: SWITCH_ORGANIZATION,
  signOut: SIGN_OUT,
};

export const USER_CARD_ITEMS: Array<UserCardItem> = [
  {
    title: USER_CARD_ITEM_TITLES.accountManagement,
    url: '/profile',
  },
  {
    title: USER_CARD_ITEM_TITLES.switchOrg,
    url: `../..${RoutePath.ORG_SWITCHER}`,
  },
  {
    title: USER_CARD_ITEM_TITLES.signOut,
    url: `../..${RoutePath.LOGOUT}`,
  },
];
